module.exports = __webpack_public_path__ + "img/logo-tradelinks-horizontal-branco.5d974eec.png";